import { useCompanySettings } from '../../../company-settings/api/use-company-settings';

export const useSkillDescriptionsExpandable = (): boolean => {
    const { data: companySettings } = useCompanySettings();

    return companySettings?.expandableSkillDescriptions ?? true;
};
